import { axios } from "~/plugins/request"
export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
	initOrgDictionary() {
		return new Promise((resolve, reject) => {
			let typeCode = { typeCode: "orgType" }
			let getOrgType = axios.get("/dictionary/findAllItemByTypeCode", { params: typeCode })
			let intCode = { typeCode: "institutionType" }
			let getIntType = axios.get("/dictionary/findAllItemByTypeCode", { params: intCode })
			let intenCode = { typeCode: "intenType" }
			let getIntenType = axios.get("/dictionary/findAllItemByTypeCode", { params: intenCode })
			let provinceCode = { typeCode: "provinceType" }
			let provinceType = axios.get("/dictionary/findAllItemByTypeCode", { params: provinceCode })
			let orgTree = axios.get(`/org/findOrgTree`)
			Promise.all([orgTree, getOrgType, getIntType, getIntenType, provinceType]).then(res => {
				resolve(res)
			}).catch(error => {
				console.log(error)
			})
		})
	},
	deleteOrg({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/org/deleteOrg`, { params }).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	findOrgTree({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/org/findOrgTree`, { params }).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	findOrgTreeByCurrentUser({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/org/findOrgTreeByCurrentUser`, { params }).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	findOrgTreeNoTwo({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/org/findOrgTreeNoTwo`, { params }).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
  findOrgNotTree({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/org/findOrgNotTree`, { params }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
	findByParentId({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/org/findByParentId`, { params }).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	deactivateOrg({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/org/deactivateOrg`, { params }).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	unbundling({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/org/unbundling`, { params }).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	recoveryOrg({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/org/recoveryOrg`, { params }).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},

	findById({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/org/findById`, { params }).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	save({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/org/save`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	authentication({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/bestSign/registerUser`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	identity2({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/bestSign/identity2`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	selectCStatus({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/customer/selectCStatus`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	findAreaByParentId({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/org/findAreaByParentId`, { params }).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	checkArea({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/org/checkArea`, { params }).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
  saveTrialTime({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/org/saveTrial`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
